// DropdownMenu.jsx
"use client";

import React from "react";
import { BiChevronDown } from "react-icons/bi";
import HaderDropdown from "./HaderDropdown";

const DropdownMenu = ({ title, menuKey, navTextColor, isOpen, onHoverToggle, onClickToggle, dropdownRef, mainItems, subCategoryMap }) => {
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onClickToggle(menuKey);
    };

    return (
        <div
            ref={dropdownRef}
            className="dropsub"
            onMouseEnter={() => onHoverToggle(menuKey, true)}
            onMouseLeave={() => onHoverToggle(menuKey, false)}
        >
            <div className={`menuTitle ${navTextColor} flex MenuList items-center gap-1 cursor-pointer !font-manrope transition-colors duration-200 xl:text-[17px] lg:text-base text-sm xl:py-2.5 xl:px-4 py-2 px-1`} onClick={handleClick}>
                {title}
                <div className="transform transition-transform duration-300 ease-in-out"
                    style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}
                >
                    <BiChevronDown className={`text-lg ${navTextColor}`} />
                </div>
            </div>
            <HaderDropdown
                isOpen={isOpen}
                onClose={() => onHoverToggle(menuKey, false)}
                navTextColor={navTextColor}
                mainItems={mainItems}
                subCategoryMap={subCategoryMap}
            />
        </div>
    );
};

export default DropdownMenu;
